import { get, post } from "./Api";

export function SearchCampaign({ lineId }) {
  return get({ url: `/api/v1/haire/search/campaign/${lineId}` });
}

export function SearchCampaignDetail({ data }) {
  return post({ url: `/api/v1/haire/search/campaign/detail`  , data});
}

export function SearchCampaignHistory(lineId, params) {
  return get({ url: `/api/v1/haire/search/history/campaign/${lineId}`, params });
}

export function InsertBill({ data }) {
  return post({ url: `/api/v1/haire/insert/Bill`, data });
}

export function SearchPrizeLuckyDraw({ data }) {
  return post({ url: `/api/v1/haire/member/search/prizeluckydraw`, data });
}





